import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ShareAltOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Row } from 'antd';
import { colors, spacing } from '../../lib/theme';
import { logShare } from '../../lib/analyticsEvents';
import AppShareMain from './AppShareMain';
import { getUUID } from '../../lib/utils';

export default class AppShareModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // visible: false
        };
        // this.props.loadingUserDetailsState(true);
    }
    // showModal = () => {
    //     this.setState({
    //         visible: true,
    //     });
    // };

    handleCancel = e => {
        console.log(e);
        this.props.handleCancelModal();
        // this.setState({
        //     visible: false,
        // });
    };

    shareAnalytics = (method) => {
        console.dir(method);
        const { type, data } = this.props;
        if (type === 'podcasts') {
            logShare(data.collectionId, 'podcasts', method);
        } else if (type === 'episodes') {
            logShare(data.guid, 'episodes', method);
        }
    }

    render() {
        const { visible, shareUrl, title, type, data } = this.props;
        const embedUrl = `https://tedapp.ai/player-gen?uuid=${getUUID(data && data.guid || '')}`;
        const embedCode = `<iframe src="${embedUrl}" style="width: 100%; height: 200px;"></iframe>`;
        return (
            <div className=''>
                <Modal
                    title={`Share ${title}`}
                    visible={visible}
                    footer={null}
                    // onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <div className='share-buttons'>
                        <h4 style={{ marginBottom: `${spacing('lg')}` }}>
                            <span style={{ color: `${colors.primary}` }}>Share Url&#58;</span> {shareUrl}</h4>
                        <AppShareMain shareUrl={shareUrl} title={title} type={type} data={data} />
                        {type === 'episodes' &&
                            <div>
                                <p className='embed-code'>Embed this episode on your website using the snippet below</p>
                                <div className='embed-widget'>
                                    <code>
                                        {embedCode}
                                    </code>
                                </div>
                            </div>
                        }
                    </div>
                </Modal>
                <style jsx>
                    {`
                        :global(.share-buttons svg) {
                            cursor: pointer;
                        }
                        :global(.share-icon i) {
                            height: 32px;
                            width: 32px;
                            border: 2px solid;
                            border-radius: 50%;
                        }
                        :global(.share-icon svg) {
                            font-size: 1.2em;
                            margin-top: 0.35em;
                        }
                    `}
                </style>
            </div>
        );
    }
}

AppShareModal.propTypes = {
    shareUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.any.isRequired,
    visible: PropTypes.bool.isRequired,
    handleCancelModal: PropTypes.func
}